import { FeedItem } from '@knocklabs/client';
import { getNotificationItemBody } from '../feed/item/get-notification-item-body';
import { plainTextFromHtml, splitNotificationBodyHtml } from './split-notification-body-html';

export type NotificationItemContent = {
  /** Plain-text title for feed rows and toasts. */
  title: string;
  /** Remaining Knock HTML after the title paragraph; null when absent. */
  bodyHtml: string | null;
};

/**
 * Resolves user-facing title/body from Knock markdown blocks only.
 * Does not read `item.data` keys (title, ruleName, etc.) for display copy.
 */
export function getNotificationItemContent(
  item: FeedItem,
  fallbackTitle: string,
): NotificationItemContent {
  const rawHtml = getNotificationItemBody(item);
  if (!rawHtml) {
    return { title: fallbackTitle, bodyHtml: null };
  }

  const { title, bodyHtml } = splitNotificationBodyHtml(rawHtml);
  if (!title) {
    return { title: fallbackTitle, bodyHtml: null };
  }

  return { title, bodyHtml };
}

/**
 * Plain-text body for toasts (same split as the feed; tags stripped).
 */
export function getNotificationItemBodyPlainText(bodyHtml: string | null): string | null {
  if (!bodyHtml) {
    return null;
  }
  const plain = plainTextFromHtml(bodyHtml);
  return plain || null;
}
